import React, { useState } from "react";
import { IconButton, ListItemIcon, Menu, MenuItem, useTheme } from "@mui/material";
import { DotsThree, PencilSimpleLine, Trash } from "@phosphor-icons/react";

interface RowOptionsProps {
  /** Omit to hide the Edit option (e.g. delete-only rows, or no edit permission). */
  onEdit?: () => void;
  /** Omit to hide the Delete option (e.g. no delete permission). */
  onDelete?: () => void;
  /** Label for the Edit menu item. Defaults to "Edit". */
  editLabel?: string;
}

export const RowOptions: React.FC<RowOptionsProps> = ({ onEdit, onDelete, editLabel = "Edit" }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuId = "row-options-menu";
  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        size="small"
        onClick={handleOpen}
        aria-label="Row options"
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        sx={{ display: "block", margin: "0 auto" }}
      >
        <DotsThree size={20} weight="bold" />
      </IconButton>

      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {onEdit && (
          <MenuItem onClick={() => { onEdit(); handleClose(); }}>
            <ListItemIcon>
              <PencilSimpleLine size={18} />
            </ListItemIcon>
            {editLabel}
          </MenuItem>
        )}
        {onDelete && (
          <MenuItem onClick={() => { onDelete(); handleClose(); }} sx={{ color: "error.main" }}>
            <ListItemIcon>
              {/* MUI's ListItemIcon theme override pins icon color, beating `sx`
                  color:inherit — set it directly on the icon so it matches the text. */}
              <Trash size={18} color={theme.palette.error.main} />
            </ListItemIcon>
            Delete
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default RowOptions;
